import { IStoreProvider } from "../../../store/models/slots/typing/slot.interface";
import { RootState } from "../../../store/rootStore";
import { createSelector } from "reselect";

const selectRawDataProvider = (state: RootState) => state.slots;

// Create a memoized selector using reselect
export const LobbySlotsProviderSelector = (
  attribute: string,
  provider_id: number = 0
) =>
  createSelector([selectRawDataProvider], (slots) => {
    const providers = slots.providers.filter(
      (provider) =>
        provider.section === "main" ||
        provider.section === "slots" ||
        provider.section === "live" ||
        provider.section === "crash"
    );
    const savedGames = slots.savedGames[attribute];
    if (providers.length > 0) {
      return {
        provider: providers[0].providers.filter(
          (provider) => provider.id === +provider_id
        )[0] as IStoreProvider,
        games: savedGames ? savedGames.games : [],
        count: savedGames ? savedGames.count : 0,
      };
    } else {
      return {
        games: savedGames ? savedGames.games : [],
        count: savedGames ? savedGames.count : 0,
      };
    }
  });

export const LobbySlotsSelector = (attribute: string) =>
  createSelector([selectRawDataProvider], (slots) => {
    const savedGames = slots.savedGames[attribute];
    return {
      games: savedGames ? savedGames.games : [],
      count: savedGames ? savedGames.count : 0,
    };
  });
